<template>
	<div class="inicio">
		<md-layout md-flex="100" md-align="center" md-gutter="24">
			<md-layout md-flex-xsmall="100" md-flex-small="65" md-flex-medium="40" md-flex-large="30" md-flex-xlarge="20">
				<md-card class="w-100">
					<md-card-header>
						<div class="md-title">Registrar puesto</div>
						<div class="md-subhead">Los campos marcados con * son obligatorios</div>
					</md-card-header>
					<md-card-content>
						<md-input-container v-bind:class="{ 'md-input-invalid': val.v_nombre }">
							<label>Puesto</label>
							<md-input v-model="puesto.nombre_pue" required></md-input>
						</md-input-container>
						<md-input-container v-bind:class="{ 'md-input-invalid': val.v_descripcion }">
							<label>Descripción</label>
							<md-input v-model="puesto.descripcion_pue" required></md-input>
						</md-input-container>
						<md-input-container v-bind:class="{ 'md-input-invalid': val.v_depto }">
							<label for="depto_pue">Departamento</label>
							<md-select name="depto_pue" id="depto_pue" v-model="puesto.depto_pue" required>
								<md-option value="administrativo">Administrativo</md-option>
								<md-option value="operativo">Operativo</md-option>
								<md-option value="otro">Otro</md-option>
							</md-select>
						</md-input-container>
					</md-card-content>
					<md-card-actions>
						<router-link tag="md-button" to="/puestos">Cancelar</router-link>
						<md-button class="md-primary md-raised" @click.native="guardarPuesto()">Guardar</md-button>
					</md-card-actions>
				</md-card>
			</md-layout>
		</md-layout>
	</div>
</template>

<script>
	import sha1 from 'js-sha1'
	import md5 from 'blueimp-md5'
	import Snackbar from 'node-snackbar'
	export default {
		name: 'inicio',
		methods:{
			guardarPuesto(){
				if(this.validarCamposPuesto()){
					this.$http.post('puestos/guardar',{
						token: this.$session.get('token'),
						data: this.puesto
					})
					.then(response => {
						if (response.status === 200 && 'msg' in response.body) {
							Snackbar.show({
								text: response.body.msg,
								actionText:'Cerrar',
								showAction: false,
								pos: 'top-right',
							});
							this.$router.push('/puestos');
						}else{
							Snackbar.show({
								text: response.body.error,
								actionText:'Cerrar',
								showAction: false,
								pos: 'top-right',
								backgroundColor:'#F44336',
								actionTextColor:'#FFF'
							});
						}
					}, response => {
						Snackbar.show({
							text:'No se pudo establecer conexión con el servidor.',
							actionText:'Cerrar',
							showAction: false,
							pos: 'top-right',
							backgroundColor:'#F44336',
							actionTextColor:'#FFF'
						});
					});
				}
			},
			validarCamposPuesto(){
				!this.puesto.nombre_pue ? this.val.v_nombre = true : this.val.v_nombre = false;
				!this.puesto.descripcion_pue ? this.val.v_descripcion = true : this.val.v_descripcion = false;
				!this.puesto.depto_pue ? this.val.v_depto = true : this.val.v_depto = false;
				if(this.val.v_nombre || this.val.v_descripcion || this.val.v_depto){
					Snackbar.show({
						text:'Por favor llene todos los campos marcados con *',
						actionText:'Cerrar',
						showAction: false,
						pos: 'top-right',
						duration: 10000,
						backgroundColor:'#CC3D30',
						actionTextColor:'#FFF'
					});
					return false
				}else{
					return true
				}
			}
		},
		beforeCreate(){
			if (!this.$session.exists()) {
				this.$router.push('/login')
			}
		},
		data(){
			return {
				puesto: {
					nombre_pue: null,
					descripcion_pue: null,
					depto_pue: null,
				},
				val: {
					v_nombre: null,
					v_descripcion: null,
					v_depto: null,
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// PuestosNuevo.vue?250d49b6